module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-ornamental-cuadrada.322a7413.jpg";